import { Dialog, DialogContent, Box, Typography, Stack } from '@mui/material';
import { IoFlashOutline } from 'react-icons/io5';
import Button from '@/components/Common/Button';
import { AiOutlineWarning } from 'react-icons/ai';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function RejectRecommendationModal({ open, onClose, onConfirm }: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px'
        }
      }}
    >
      <DialogContent>
        <Box textAlign='center' px={2}>
          {/* Warning Circle */}
          <Box
            width={110}
            height={110}
            mx='auto'
            mb={3}
            borderRadius='50%'
            bgcolor='#FDEAEA'
            display='flex'
            alignItems='center'
            justifyContent='center'
          >
            <AiOutlineWarning size={52} color='#D92D20' />
          </Box>

          {/* Title */}
          <Typography fontSize={20} fontWeight={500} mb={1}>
            Reject Recommendation?
          </Typography>

          {/* Subtitle */}
          <Typography color='text.secondary' fontSize={14} mb={2}>
            Are you sure you want to reject this recommendation?
          </Typography>

          {/* Red Info Box */}
          <Box
            display='flex'
            alignItems='center'
            justifyContent='center'
            gap={1}
            bgcolor='#FDEAEA'
            borderRadius='4px'
            padding='8px'
            mb={3}
          >
            <IoFlashOutline color='#D92D20' size={16} fontWeight={600} />
            <Typography color='#D92D20' fontWeight={400} fontSize={16}>
              AI will never recommend this suggestion again.
            </Typography>
          </Box>

          {/* Description */}
          <Typography color='text.secondary' fontSize={16} mb={3}>
            If this issue comes up again in future calls, AI will still not have guidance for it.
          </Typography>

          {/* Buttons */}
          <Stack direction='row' spacing={3} justifyContent='end'>
            <Button
              variant='outlined'
              onClick={onClose}
              sx={{
                borderRadius: '30px',

                borderColor: '#BDBDBD',
                color: '#6B6B6B'
              }}
            >
              Cancel
            </Button>

            <Button
              variant='contained'
              onClick={onConfirm}
              sx={{
                borderRadius: '30px',
                px: 5,
                py: 1.3
              }}
            >
              Yes, Reject Permanently
            </Button>
          </Stack>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
